import axios from "axios";

export const GET_SERVICIOS_ALUMNOS_LIST    = "GET_SERVICIOS_ALUMNOS_LIST";

export const getServiciosAlumnoList = () => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getServiciosAlumnoList");
        axios
            .get("/api/ReporteAdministrativo/ObtieneServicios")
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_SERVICIOS_ALUMNOS_LIST,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_SERVICIOS_ALUMNOS_LIST,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

